import { useDashboardItemsWithQueriesLoaded } from 'hooks'

import { ICONMAP } from './icon-component.consts'
import type { IIconComponent } from './icon-component.types'

export const useIconComponentModel = ({ body, item }: IIconComponent) => {
  const { color, typeIcon, size, iconAlign } = body || {}

  const IconComponent = ICONMAP[typeIcon]

  useDashboardItemsWithQueriesLoaded({
    id: item?.id,
    type: item?.type,
    isLoaded: true,
    body,
    headers: item?.headers,
  })

  return {
    iconAlign,
    size,
    color,
    IconComponent,
  }
}
